import gql from 'graphql-tag'

export const QUERY = gql`
  query course_chapters_index($page: Int!, $perPage: Int!) {
    courseChapters(page: $page, perPage: $perPage) {
      nodes {
        id
        title
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
